import ActionTypes from "../constants/ActionTypes";

const initialState = {
    isFetching: false,
    data: [],
    count: 0,
    error: null,
}

const adminManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_ADMIN_LIST_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: action.paload,
      };
    case ActionTypes.FETCH_ADMIN_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data_list,
        count: action.payload.all_data_count,
        error: action.paload,
      };
    case ActionTypes.FETCH_ADMIN_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.paload,
      };

    default:
      return state;
  }
};

export default adminManagementReducer;
